import ky from 'ky';

/**
 * Базовый HTTP-клиент.
 * Токен подставляется через beforeRequest hook из localStorage.
 */
export const apiClient = ky.create({
  prefixUrl: '/api',
  hooks: {
    beforeRequest: [
      (request) => {
        const token = localStorage.getItem('auth_token');
        if (token) {
          request.headers.set('Authorization', `Bearer ${token}`);
        }
      },
    ],
  },
});
